import "./AboutContentStyles.css";
import React from "react";
import { Link } from "react-router-dom";

import React1 from "../../assets/react1.jpg"

import React2 from "../../assets/react2.webp"
import config from "../contact/config";
import mylogo from "../../assets/mylogo.png";

export const AboutContent = () => {

    const myDesignation = config.myDesignation;
    const contactName = config.contactName;
    
    const myCurrentRole = config.myCurrentRole;  
    return(
        <div className="about">
            <div className="left">
                <p>Who Am I ?</p>
                <p>{contactName}</p>
                <p>{myCurrentRole} and {myDesignation}</p>
                <img src={mylogo} alt="[PCAP-31-03] PCAP" />
                <Link to="/contact">
                    <button className="btn">Contact</button>
                </Link>
            </div>

            <div className="right">
                <div className="img-container">
                    <div className="img-stack top">
                        <img src={React1} className="img" alt="true"/>
                    </div>

                    <div className="img-stack bottom">
                        <img src={React2} className="img" alt="true"/>
                    </div>
                </div>
            </div>
        </div>
    )



}